import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApprovalsRoutingModule } from './approvals-routing.module';
import { ChemistAddtionalApprovalComponent } from './chemistaddtionalapproval/chemistaddtionalapproval.component';
import { DcrUnlockApprovalComponent } from './dcrunlockapproval/dcrunlockapproval.component';
import { LateDayplanApprovalComponent } from './latedayplanapproval/latedayplanapproval.component';
import { RouteAddtionalApprovalComponent } from './routeaddtionalapproval/routeaddtionalapproval.component';
import { RouteDivertApprovalComponent } from './routedivertapproval/routedivertapproval.component';
import { TPAddEditApprovalComponent } from './tpaddeditapproval/tpaddeditapproval.component';
import { IMEIResetComponent } from './imeireset/imeireset.component';




@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        AgGridModule.withComponents([]),
        ApprovalsRoutingModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        ChemistAddtionalApprovalComponent,
        DcrUnlockApprovalComponent,
        LateDayplanApprovalComponent,
        RouteAddtionalApprovalComponent,
        RouteDivertApprovalComponent,
        TPAddEditApprovalComponent,
        IMEIResetComponent
    ],
    providers: [],
    exports: [RouterModule,RouteAddtionalApprovalComponent]
})
export class ApprovalsModule {

}
